import React, { useEffect, useState } from 'react';
import {
  Alert,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Descriptions,
  Form,
  Input,
  InputNumber,
  Layout,
  Modal,
  notification,
  Popconfirm,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Typography,
} from 'antd';

import {
  catchExceptionSRate,
  validatorNumbers,
} from '../../utils/helpers/helpers';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import MESSAGES from '../../enums/Messages';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import {
  post,
  get,
  put,
  removePlace,
  postPlace,
  placeTable,
} from '../../api/module/announcement_rol';
import { get as getAnnouncementById } from '../../api/module/announcement';
import { getAll as getContractTypes } from '../../api/module/contract_types';

import { getAll as getCountries } from '../../api/module/countries';
import { getByCountry as getStates } from '../../api/module/states';
import {
  getByState as getCitiesByState,
  getByCountry as getCitiesByCountry,
} from '../../api/module/cities';
import {
  AjaxTable,
  CustomButton,
  CustomSelector,
  CustomTooltip,
} from '../../components';
import dayjs from 'dayjs';
import { PlusOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { Link, useHistory } from 'react-router-dom';

const { Content } = Layout;
const { Title } = Typography;
const { TextArea } = Input;

const timeUnitOptions = [
  { value: 'HRS', label: 'Horas' },
  { value: 'DAY', label: 'Días' },
  { value: 'WRE', label: 'Semanas' },
  { value: 'MON', label: 'Meses' },
];

const periodOptions = [
  {
    value: 1,
    label: 'Mensual',
  },
  {
    value: 2,
    label: 'Total contrato',
  },
  {
    value: 3,
    label: 'Entrega de productos',
  },
  {
    value: 4,
    label: 'Otro ¿Cuál?',
  },
];

const APPlace = ({ rol_id }) => {
  const [initialValues, setInitialValues] = useState();
  const [reloadSource, setReloadSource] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const [loadingForm, setLoadingForm] = useState(false);

  const [form] = Form.useForm();

  const handleDelete = async (id) => {
    setDeleteID(id);
    try {
      await removePlace(id);
      setReloadSource({});
    } catch (error) {
      catchExceptionSRate(error);
    } finally {
      setDeleteID(undefined);
    }
  };
  const placeColumns = [
    {
      title: 'País',
      dataIndex: 'pais_texto',
    },
    {
      title: 'Departamento',
      dataIndex: 'estado_texto',
    },
    {
      title: 'Ciudad/Municipio',
      dataIndex: 'ciudad_texto',
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => {
        return (
          <CustomButton
            block
            type={'default'}
            htmlType={'button'}
            loading={record.id === deleteID}
            danger
            text={
              <Popconfirm
                title="¿Ésta seguro de eliminar este lugar?"
                onConfirm={() => handleDelete(record.id)}
              >
                Eliminar
              </Popconfirm>
            }
          />
        );
      },
    },
  ];

  const onFinish = async (values) => {
    setLoadingForm(true);
    try {
      const data = {
        ...values,
        rol: rol_id,
      };
      await postPlace(data);
      setReloadSource({});
      setInitialValues();
    } catch (error) {
      catchExceptionSRate(error);
    } finally {
      setLoadingForm(false);
    }
  };

  return (
    <>
      <CustomButton
        type={'default'}
        className={'ant-btn-info'}
        htmlType="button"
        onClick={() => setInitialValues({ open: true })}
        text={
          <>
            <PlusOutlined /> Agregar lugar de ejecución
          </>
        }
      />
      <Modal
        open={initialValues?.open}
        destroyOnClose
        footer={null}
        closable={false}
        title={
          <>
            Lugar de ejecución
            <CustomTooltip
              placement="top"
              title="Seleccione el País, Departamento (aplica para Colombia) y ciudad en que se desarrollarán las actividades  del contrato o en el que se hace la donación"
            />
          </>
        }
      >
        <Form
          onFinish={onFinish}
          initialValues={initialValues}
          layout="vertical"
          form={form}
        >
          <Form.Item
            name="pais"
            label="País"
            rules={[{ required: true }]}
            valuePropName="initialValue"
          >
            <CustomSelector
              endpointFetch={getCountries}
              valueName="id"
              labelName="nombre"
            />
          </Form.Item>
          <Form.Item noStyle dependencies={['pais']}>
            {({ getFieldValue, setFieldsValue }) => {
              const p = getFieldValue('pais');
              if (p === 9999999)
                return (
                  <Form.Item
                    label="Países varios"
                    name="pais_varios"
                    rules={[{ required: true }]}
                  >
                    <TextArea placeholder="Digite los países" />
                  </Form.Item>
                );
              else setFieldsValue({ pais_varios: undefined });
              return null;
            }}
          </Form.Item>
          <Form.Item noStyle dependencies={['pais']}>
            {({ getFieldValue, setFieldsValue }) => {
              const p = getFieldValue('pais');
              if (p !== initialValues?.pais)
                setFieldsValue({ estado: undefined, estado_varios: undefined });
              if (p === 45)
                return (
                  <Form.Item
                    name="estado"
                    label="Departamento"
                    valuePropName="initialValue"
                  >
                    <CustomSelector
                      endpointFetch={async () => {
                        const res = await getStates(p);
                        res.data.results.push({
                          id: 9999999,
                          nombre: 'Varios',
                        });
                        return res;
                      }}
                      valueName="id"
                      labelName="nombre"
                      selectorKey={p}
                      allowClear
                    />
                  </Form.Item>
                );
              return (
                <Form.Item name="estado" label="Departamento">
                  <Select
                    options={[
                      {
                        value: 9999999,
                        label: 'Varios',
                      },
                    ]}
                    allowClear
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
          <Form.Item noStyle dependencies={['estado']}>
            {({ getFieldValue, setFieldsValue }) => {
              const p = getFieldValue('estado');
              if (p === 9999999)
                return (
                  <Form.Item name="estado_varios">
                    <TextArea
                      placeholder="Digite los departamentos"
                      allowClear
                    />
                  </Form.Item>
                );
              else setFieldsValue({ estado_varios: undefined });
              return null;
            }}
          </Form.Item>
          <Form.Item noStyle dependencies={['pais', 'estado']}>
            {({ getFieldValue, setFieldsValue }) => {
              const p = getFieldValue('pais');
              const d = getFieldValue('estado');
              if (p !== initialValues?.pais || d !== initialValues?.estado)
                setFieldsValue({ ciudad: undefined, ciudad_varios: undefined });
              if (!p || p === 9999999 || d === 9999999) {
                return (
                  <Form.Item name="ciudad" label="Ciudad">
                    <Select
                      options={[
                        {
                          value: 9999999,
                          label: 'Varios',
                        },
                      ]}
                      allowClear
                    />
                  </Form.Item>
                );
              } else {
                return (
                  <Form.Item
                    name="ciudad"
                    label="Ciudad"
                    valuePropName="initialValue"
                  >
                    <CustomSelector
                      endpointFetch={async () => {
                        let res;
                        if (!d) {
                          res = await getCitiesByCountry(p);
                        } else {
                          res = await getCitiesByState(d);
                        }
                        res.data.results.push({
                          id: 9999999,
                          nombre: 'Varios',
                        });
                        return res;
                      }}
                      valueName="id"
                      labelName="nombre"
                      selectorKey={`${p}_${d}`}
                      allowClear
                    />
                  </Form.Item>
                );
              }
            }}
          </Form.Item>
          <Form.Item noStyle dependencies={['ciudad']}>
            {({ getFieldValue, setFieldsValue }) => {
              const p = getFieldValue('ciudad');
              if (p === 9999999)
                return (
                  <Form.Item name="ciudad_varios">
                    <TextArea placeholder="Digite las ciudades" allowClear />
                  </Form.Item>
                );
              else setFieldsValue({ ciudad_varios: undefined });
              return null;
            }}
          </Form.Item>
          <Space
            direction="horizontal"
            style={{ justifyContent: 'space-around', width: '100%' }}
          >
            <CustomButton
              htmlType="button"
              text="Cancelar"
              type="default"
              disabled={loadingForm}
              onClick={() => setInitialValues()}
            />
            <CustomButton
              htmlType="button"
              onClick={() => form.submit()}
              type="primary"
              text="Guardar"
              loading={loadingForm}
            />
          </Space>
        </Form>
      </Modal>

      <AjaxTable
        columns={placeColumns}
        tableTitle={'Listado de lugares de ejecución'}
        endpoint={placeTable}
        reloadSource={reloadSource}
        searchInput
        scroll={{ x: false }}
        query={{
          rol: rol_id,
        }}
        showSizeChanger
      />
    </>
  );
};

const AnnouncementPosition = () => {
  const navigate = useHistory();

  const { id: position_id, announcement_id } = useParams();
  const [announcement, setAnnouncement] = useState(null);

  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [form] = Form.useForm();

  const breadcrumbItems = [
    {
      text: 'Convocatoria',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT}`,
    },
    {
      text: 'Convocatoria en curso',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_PROGRESS}`,
    },
    {
      text: 'Editar Convocatoria',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_FORM}/${announcement_id}`,
    },
    {
      text: `${position_id ? 'Editar' : 'Crear'} Cargo de Convocatoria`,
    },
  ];

  useEffect(() => {
    async function getAnnouncement() {
      try {
        let response = await getAnnouncementById(announcement_id);
        setAnnouncement(response.data);
      } catch (err) {
        catchExceptionSRate(err);
      }
    }
    async function handleGetPosition() {
      try {
        const { data } = await get(position_id);
        setInitialValues({
          ...data,
          tipo_remuneracion: !!data.remuneracion_fija
            ? 1
            : !!data.remuneracion_variable
              ? 2
              : null,
          fecha_inicio: data.fecha_inicio
            ? dayjs(data.fecha_inicio)
            : undefined,
        });
      } catch (err) {
        catchExceptionSRate(err);
      }
    }
    if (announcement_id) getAnnouncement();
    if (position_id) handleGetPosition();
  }, [announcement_id, position_id]);

  const contractTypeSelectorWithOther = async () => {
    const { data: resData } = await getContractTypes();
    return {
      data: {
        results: [
          {
            id: 0,
            nombre: 'Por definir',
          },
          ...resData.results,
        ],
      },
    };
  };

  const save = async (data) => {
    try {
      setLoading(true);
      data.convocatoria = announcement_id;

      if (data.tiempo_experiencia_laboral === '') {
        data.tiempo_experiencia_laboral = null;
      }
      if (data?.fecha_inicio) {
        data.fecha_inicio = dayjs(data.fecha_inicio).format('YYYY-MM-DD');
      }
      let response;
      if (position_id) {
        response = await put(position_id, data);
      } else {
        response = await post(data);
      }
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
      Modal.info({
        title: 'Recuerde',
        content:
          'Una vez guarde la información, en este formulario podrá registrar el/los lugar/es de realización de labores',
        closable: false,
        onOk: () => {
          setLoading(false);
          if (!position_id) {
            navigate.push(
              `${INTERNAL_LINKS.ANNOUNCEMENT_POSITION}/${announcement_id}/${response.data.id}/`,
            );
            navigate.go(0);
          }
        },
      });
    } catch (err) {
      setLoading(false);
      catchExceptionSRate(err);
    }
  };

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      {position_id ? (
        <Title className={'text-uppercase'} level={2}>
          Editar cargo en convocatoria
        </Title>
      ) : (
        <Title className={'text-uppercase'} level={2}>
          Crear cargo en convocatoria
        </Title>
      )}
      {!announcement ? (
        <Skeleton loading active />
      ) : (
        <>
          <Descriptions
            title="Información de la convocatoria"
            bordered
            column={2}
          >
            <Descriptions.Item label="Número de convocatoria">
              {announcement.numero}
            </Descriptions.Item>
            <Descriptions.Item label="Nombre de la convocatoria">
              {announcement.nombre}
            </Descriptions.Item>
          </Descriptions>
          <Form
            form={form}
            layout="vertical"
            onFinish={save}
            initialValues={initialValues}
            scrollToFirstError
            autoComplete="off"
          >
            <Card
              size={'small'}
              bordered={false}
              title={<Title level={3}>Agregar Cargo/Rol</Title>}
            >
              <Form.Item
                name="cargo"
                label="Cargo/Rol de la convocatoria"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input.TextArea
                  rows={1}
                  placeholder="Cargo/Rol de la convocatoria"
                  allowClear
                  maxLength={100}
                  showCount
                />
              </Form.Item>
              <Form.Item
                name="observaciones_cargo"
                label="Otras observaciones para el cargo"
              >
                <Input.TextArea rows={2} allowClear />
              </Form.Item>
              <Row gutter={12}>
                <Col span={8}>
                  <Form.Item
                    name="tipo_contrato"
                    label="Tipo Contrato"
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    valuePropName="initialValue"
                  >
                    <CustomSelector
                      selectorProps={{
                        style: { width: '100%' },
                        placeholder: 'Seleccione el tipo de contrato...',
                      }}
                      valueName="id"
                      labelName="nombre"
                      endpointFetch={contractTypeSelectorWithOther}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="unidad_tiempo"
                    label="Unidad de tiempo del proyecto"
                  >
                    <Select
                      style={{ width: '100%' }}
                      placeholder="Seleccione unidad de tiempo..."
                      options={timeUnitOptions}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="duracion"
                    label="Duración del proyecto"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value) {
                            return Promise.resolve();
                          } else if (isNaN(value)) {
                            return Promise.reject(
                              new Error('Debe ser un valor numérico'),
                            );
                          }
                          if (value < 0) {
                            return Promise.reject(
                              new Error('Debe ser positivo'),
                            );
                          }
                          if (
                            value.toString().includes('.') &&
                            value.toString().split('.', 2)[1].length > 2
                          ) {
                            return Promise.reject(
                              new Error(
                                'Debe ser un valor con máximo dos decimales',
                              ),
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      placeholder="Duración del proyecto en meses"
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    name="total_vacantes"
                    label="Total vacantes"
                    rules={[
                      {
                        required: true,
                      },
                      validatorNumbers(),
                    ]}
                  >
                    <Input placeholder="Total vacantes" allowClear />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item name="tipo_remuneracion">
                <Radio.Group
                  options={[
                    {
                      value: 1,
                      label: 'Remuneración fija',
                    },
                    {
                      value: 2,
                      label: 'Remuneración variable / otros',
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item noStyle dependencies={['tipo_remuneracion']}>
                {({ getFieldValue }) => {
                  const tr = getFieldValue('tipo_remuneracion');
                  if (tr === 1)
                    return (
                      <Form.Item
                        name="remuneracion_fija"
                        label="Remuneración fija"
                        rules={[{ required: true }]}
                      >
                        <InputNumber
                          min={0}
                          style={{ width: '100%' }}
                          formatter={(value) =>
                            `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                          }
                          parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                          placeholder="Remuneración fija..."
                        />
                      </Form.Item>
                    );
                  if (tr === 2)
                    return (
                      <Form.Item
                        name="remuneracion_variable"
                        label="Remuneración variable"
                        rules={[{ required: true }]}
                      >
                        <Input.TextArea
                          rows={2}
                          style={{ width: '100%' }}
                          placeholder="Remuneración variable"
                        />
                      </Form.Item>
                    );
                  return null;
                }}
              </Form.Item>
              <Row gutter={12}>
                <Col span={6}>
                  <Form.Item name="periodo" label="Período">
                    <Select
                      allowClear
                      placeholder="Período"
                      options={periodOptions}
                    />
                  </Form.Item>
                </Col>
                <Form.Item noStyle dependencies={['periodo']}>
                  {({ getFieldValue }) =>
                    getFieldValue('periodo') === 4 ? (
                      <Col span={8}>
                        <Form.Item
                          name="periodo_cual"
                          label="¿Cuál?"
                          rules={[{ required: true }]}
                        >
                          <Input allowClear />
                        </Form.Item>
                      </Col>
                    ) : null
                  }
                </Form.Item>
                <Col span={8}>
                  <Form.Item
                    name="fecha_inicio"
                    label="Fecha estimada de inicio de labores"
                  >
                    <DatePicker
                      placeholder="Fecha inicio..."
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Card
              size={'small'}
              bordered={false}
              title={<Title level={3}>Requisitos del cargo</Title>}
            >
              <Form.Item
                name="estudios"
                label="Estudios"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input.TextArea
                  maxLength={1000}
                  showCount
                  placeholder="Estudios"
                  allowClear
                  rows={2}
                />
              </Form.Item>
              <Form.Item
                name="tipo_experiencia_laboral"
                label="Tipo de experiencia laboral"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input.TextArea
                  maxLength={1000}
                  showCount
                  placeholder="Experiencia Laboral"
                  allowClear
                  rows={2}
                />
              </Form.Item>
              <Row gutter={12}>
                <Col span={8}>
                  <Form.Item
                    name="tiempo_experiencia_laboral"
                    label="Tiempo de experiencia laboral (meses)"
                    rules={[
                      { required: true },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            getFieldValue('tiempo_experiencia_laboral') != null
                          ) {
                            if (new RegExp('^[0-9]*$').test(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(`Ingrese únicamente números`),
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                  >
                    <Input
                      placeholder="Tiempo de experiencia laboral en meses..."
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="disponibilidad_viajar"
                    label="Viajar y/o desplazarse"
                    valuePropName="checked"
                  >
                    <Checkbox>
                      Disponibilidad para viajar/desplazarse durante el proyecto
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="radicarse_otra_ciudad"
                    label="Vivir en otra ciudad"
                    valuePropName="checked"
                  >
                    <Checkbox>
                      Posibilidad de radicarse en otra ciudad durante el
                      proyecto
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            {position_id ? (
              <Card
                size={'small'}
                bordered={false}
                title={<Title level={3}>Lugar de realización labores</Title>}
              >
                <APPlace rol_id={position_id} />
              </Card>
            ) : null}
            <Alert
              style={{ marginBottom: 15 }}
              type="info"
              showIcon
              description={
                <b>Marque los requerimientos técnicos para la selección</b>
              }
            />
            <Row gutter={12}>
              <Col span={8}>
                <Form.Item
                  name="prueba_especifica"
                  rules={[
                    {
                      validator(_, value) {
                        if (
                          !value &&
                          !!!form.getFieldValue('entrevista') &&
                          !!!form.getFieldValue('prueba_psicotecnica')
                        )
                          return Promise.reject(new Error('Campo requerido'));
                        return Promise.resolve();
                      },
                    },
                  ]}
                  dependencies={['entrevista', 'prueba_psicotecnica']}
                  valuePropName="checked"
                >
                  <Checkbox>Prueba específica</Checkbox>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="entrevista"
                  rules={[
                    {
                      validator(_, value) {
                        if (
                          !value &&
                          !!!form.getFieldValue('prueba_especifica') &&
                          !!!form.getFieldValue('prueba_psicotecnica')
                        )
                          return Promise.reject(new Error('Campo requerido'));
                        return Promise.resolve();
                      },
                    },
                  ]}
                  dependencies={['prueba_especifica', 'prueba_psicotecnica']}
                  valuePropName="checked"
                >
                  <Checkbox>Entrevista</Checkbox>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="prueba_psicotecnica"
                  rules={[
                    {
                      validator(_, value) {
                        if (
                          !value &&
                          !!!form.getFieldValue('entrevista') &&
                          !!!form.getFieldValue('prueba_especifica')
                        )
                          return Promise.reject(new Error('Campo requerido'));
                        return Promise.resolve();
                      },
                    },
                  ]}
                  dependencies={['entrevista', 'prueba_especifica']}
                  valuePropName="checked"
                >
                  <Checkbox>Prueba psicotécnica</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <Space>
              <CustomButton
                htmlType="submit"
                loading={loading}
                text="Guardar"
              />
              <Link
                to={`${INTERNAL_LINKS.ANNOUNCEMENT_FORM}/${announcement_id}`}
              >
                <CustomButton
                  type={'default'}
                  className={'back-button'}
                  htmlType="button"
                  text="Volver"
                />
              </Link>
            </Space>
          </Form>
        </>
      )}
    </Content>
  );
};

export default AnnouncementPosition;
